module.exports = __webpack_public_path__ + "static/media/8.ef11ee56.JPG";